import { getModuleColor } from 'app/Module';
import React from 'react';
import { Area, CartesianGrid, ComposedChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

function DailyActivityChart({ data }) {
  const dataSample = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;


  const CustomTooltip = ({ label, payload }) => {


    console.log({ label, payload })
    return (
      <div className="custom-tooltip bg-dark card">
        {payload.map(item => (
          item.value > 0 && < div key={item.dataKey} className="card-header" style={{ color: item.fill }} > <b>{item.dataKey}</b> {item.value}</div>
        ))}
        <div className="card-footer">{label}</div>
      </div >
    );

  };


  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" opacity={0.5} />
        <XAxis dataKey="name" angle={0} fontSize={16} />
        <YAxis allowDecimals={false} />
        <Tooltip content={CustomTooltip} />
        <Legend />
        <Area connectNulls type="monotone" dataKey="OVERALL" stackId="3" stroke="gray" fill="gray" fillOpacity={0} strokeOpacity={0.5} strokeWidth={0} activeDot={{ r: 8 }} />
        {
          data.some(row => row.CORE > 0) &&
          <Area connectNulls type="monotone" dataKey="CORE" stackId="0" stroke={getModuleColor("CORE")} fill={getModuleColor("CORE")} strokeWidth={1} />
        }
        {
          data.some(row => row.HR > 0) &&
          <Area connectNulls type="monotone" dataKey="HR" stackId="0" stroke={getModuleColor("HR")} fill={getModuleColor("HR")} strokeWidth={0} />
        }
        {
          data.some(row => row.WHISTLE > 0) &&
          <Area connectNulls type="monotone" dataKey="WHISTLE" stackId="0" stroke={getModuleColor("WHISTLE")} fill={getModuleColor("WHISTLE")} strokeWidth={0} />
        }
        {
          data.some(row => row.ADMIN > 0) &&
          <Area connectNulls type="monotone" dataKey="ADMIN" stackId="0" stroke={getModuleColor("ADMIN")} fill={getModuleColor("ADMIN")} strokeWidth={0} />
        }
        {
          data.some(row => row.HEALTH > 0) &&
          <Area connectNulls type="monotone" dataKey="HEALTH" stackId="0" stroke={getModuleColor("HEALTH")} fill={getModuleColor("HEALTH")} strokeWidth={0} />
        }
        {
          data.some(row => row.SAFETY > 0) &&
          <Area connectNulls type="monotone" dataKey="SAFETY" stackId="0" stroke={getModuleColor("SAFETY")} fill={getModuleColor("SAFETY")} strokeWidth={0} />
        }
        {
          data.some(row => row.DEVICES > 0) &&
          <Area connectNulls type="monotone" dataKey="DEVICES" stackId="0" stroke={getModuleColor("DEVICES")} fill={getModuleColor("DEVICES")} strokeWidth={0} />
        }
      </ComposedChart>
    </ResponsiveContainer>
  );

}

export default DailyActivityChart